import { z } from "zod"

import { entityIdSchema, tenantIdSchema } from "./identifiers.js"
import { safeEntitySummaryV1Schema } from "./command-result-v1.js"

export const projectionFreshnessV1Schema = z
  .object({
    status: z.enum(["fresh", "stale"]),
    sourceAvailable: z.boolean(),
    lastSuccessfulSyncAt: z.iso.datetime({ offset: true }).nullable(),
    evaluatedAt: z.iso.datetime({ offset: true }),
    staleAfterSeconds: z.number().int().positive().max(3600),
  })
  .strict()

export const foundationProjectionRecordV1Schema = z
  .object({
    tenantId: tenantIdSchema,
    entityType: z.literal("foundation_state"),
    entityId: entityIdSchema,
    state: safeEntitySummaryV1Schema.shape.state,
    version: safeEntitySummaryV1Schema.shape.version,
    sourceEventId: z.string().regex(/^[a-f0-9]{64}$/),
    sourceOccurredAt: z.iso.datetime({ offset: true }),
  })
  .strict()

const foundProjectionV1Schema = z
  .object({
    projectionVersion: z.literal(1),
    found: z.literal(true),
    record: foundationProjectionRecordV1Schema,
    freshness: projectionFreshnessV1Schema,
  })
  .strict()

const missingProjectionV1Schema = z
  .object({
    projectionVersion: z.literal(1),
    found: z.literal(false),
    tenantId: tenantIdSchema,
    entityType: z.literal("foundation_state"),
    entityId: entityIdSchema,
    freshness: projectionFreshnessV1Schema,
  })
  .strict()

export const foundationProjectionReadV1Schema = z.discriminatedUnion("found", [
  foundProjectionV1Schema,
  missingProjectionV1Schema,
])

export type ProjectionFreshnessV1 = z.infer<typeof projectionFreshnessV1Schema>
export type FoundationProjectionRecordV1 = z.infer<typeof foundationProjectionRecordV1Schema>
export type FoundationProjectionReadV1 = z.infer<typeof foundationProjectionReadV1Schema>
